import { IPaging, Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

export const emptySource = new Crud({
  fetcher: new Static([] as unknown[]),
  keyField: 'key',
})

export const defaultPaging: IPaging = {
  page: 0,
  pageSize: 10000,
}

export enum CrudHistoryOperations {
  UPDATE = 'UPDATE',
  INSERT = 'INSERT',
  DELETE = 'DELETE',
}
